
import styles from './Chip.module.scss'

export default function({highlighted, children}: {highlighted?: boolean, children: any}) {
  return <span className={`${styles.chip} ${highlighted ? styles.highlighted : ''}`}>{children}</span>
}
